<template>
  <div class="case-details-page-container">
    <nav-bar></nav-bar>
    <div class="case-details-container">
      <div class="title">
        <div class="main-title">
          <span>{{ showCaseDetails.name }}</span>
        </div>
        <div class="sub-title">
          <span>{{ showCaseDetails.desc }}</span>
        </div>
      </div>
      <div class="case-img-container">
        <img :src="showCaseDetails.imgUrl" alt=""/>
      </div>
    </div>
    <contact-us></contact-us>
    <page-footer></page-footer>
    <card-btn @click.native="openCard"></card-btn>
    <business-card ref="businessCard"></business-card>
  </div>
</template>

<script>
  import navBar from "@/components/navBar";
  import contactUs from "@/components/contactUs";
  import pageFooter from "@/components/pageFooter";
  import cardBtn from "@/components/cardBtn";
  import businessCard from "@/components/businessCard";

  export default {
    components: {
      navBar,
      contactUs,
      pageFooter,
      cardBtn,
      businessCard,
    },
    mounted() {
      this.backtop();
      this.showCaseId = this.$route.query.id;
      this.getShowCase();
    },
    data() {
      return {
        showCaseId: null,
        showCaseDetails: {},
        caseDetailsData: [
          {
            id: 1,
            name: "督促系统",
            desc: "执前督促溯源治理系统",
            imgUrl: require("@/assets/image/dcxt-details.png"),
          },
          {
            id: 2,
            name: "速证云",
            desc: "赋予强制执行视频面签工具",
            imgUrl: require("@/assets/image/szy-details.png"),
          },
          {
            id: 3,
            name: "玛莉亚U+",
            desc: "医疗综合服务营销平台",
            imgUrl: require("@/assets/image/mlyu+-details.png"),
          },
          {
            id: 4,
            name: "KAPIPO",
            desc: "线上少儿教育平台",
            imgUrl: require("@/assets/image/kapipo-details.png"),
          },
          {
            id: 5,
            name: "乐谷农业",
            desc: "线上线下票务系统",
            imgUrl: require("@/assets/image/lgny-details.png"),
          },
          {
            id: 6,
            name: "众诺CRM",
            desc: "医疗客户管理SaaS系统",
            imgUrl: require("@/assets/image/zncrm-details.png"),
          },
          {
            id: 7,
            name: "PDF合并",
            desc: "PDF合并/管理工具",
            imgUrl: require("@/assets/image/pdf-details.png"),
          },
          {
            id: 8,
            name: "审批签章",
            desc: "杭州国土局签章审批平台",
            imgUrl: require("@/assets/image/qzsp-details.png"),
          },
          {
            id: 9,
            name: "在线投票",
            desc: "杭州国土局在线投票平台",
            imgUrl: require("@/assets/image/zxtp-details.png"),
          },
          {
            id: 10,
            name: "识别系统",
            desc: "杭州国土局信息识别系统",
            imgUrl: require("@/assets/image/sbxt-details.png"),
          },
          {
            id: 11,
            name: "OA系统",
            desc: "智能OA系统",
            imgUrl: require("@/assets/image/sjoa-details.png"),
          },
          {
            id: 12,
            name: "社交应用",
            desc: "附近真人在线社交应用",
            imgUrl: require("@/assets/image/sjyy-details.png"),
          },
          {
            id: 13,
            name: "超声影像系统",
            desc: '超声影像系统',
            imgUrl: require("@/assets/image/csyxst-details.png"),
          },
          {
            id: 14,
            name: "慈善捐助",
            desc: '杭州西湖慈善总会捐助平台',
            imgUrl: require("@/assets/image/csjz-details.png"),
          },
          {
            id: 15,
            name: "深时数字地球",
            desc: '深时数字地球平台',
            imgUrl: require("@/assets/image/ssszdq-details.png"),
          },
          {
            id: 16,
            name: "古生物矿物学",
            desc: '古生物矿物学数据库',
            imgUrl: require("@/assets/image/gswkwx-details.png"),
          },
          {
            id: 17,
            name: "矿物蚀变",
            desc: '矿物蚀变提取平台',
            imgUrl: require("@/assets/image/kwsb-details.png"),
          },
          {
            id: 18,
            name: "DDE竞赛",
            desc: 'DDE全国大学生地质竞赛',
            imgUrl: require("@/assets/image/dde-details.png"),
          },
          {
            id: 19,
            name: "伏羲 ",
            desc: '全球综合观测大数据知识化管理与服务平台',
            imgUrl: require("@/assets/image/fuxi-details.png"),
          },
          {
            id: 20,
            name: "物产中大",
            desc: '物产中大项目资源库',
            imgUrl: require("@/assets/image/wczd-details.png"),
          },
          {
            id: 21,
            name: "至信云调",
            desc: '线上多元纠纷调解系统（PC端）',
            imgUrl: require("@/assets/image/zxyt-details.png"),
          },
          {
            id: 22,
            name: "IDDIS",
            desc: '国际灾害数据和信息服务 ',
            imgUrl: require("@/assets/image/iddis-details.png"),
          },
          {
            id: 23,
            name: "猩猩牌谱",
            desc: '德州扑克牌谱生成工具',
            imgUrl: require("@/assets/image/xxpp-details.png"),
          },
          {
            id: 24,
            name: "企业微信",
            desc: '医疗CRM+企业微信生态',
            imgUrl: require("@/assets/image/qywx-details.png"),
          },
          {
            id: 25,
            name: "DDEMR",
            desc: '深时数字地球与矿产资源',
            imgUrl: require("@/assets/image/ddemr-details.png"),
          },
          {
            id: 26,
            name: "多元纠纷化解",
            desc: '线上多元纠纷调解系统（小程序）',
            imgUrl: require("@/assets/image/dyjfhj-details.png"),
          },
        ],
      };
    },
    methods: {
      getShowCase() {
        this.showCaseDetails = this.caseDetailsData[this.showCaseId - 1];
      },
      checkMenuIndexChange(index) {
        //   this.$router.push({
        //     path: "/details",
        //     query: {
        //       menuIndex: index,
        //     },
        //   });
      },
      // 回到顶部
      backtop() {
        var timer = setInterval(function () {
          let osTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            osTop + ispeed;
          if (osTop === 0) {
            clearInterval(timer);
          }
          this.isTop = true;
        }, 20);
      },
      openCard() {
        this.$refs.businessCard.open();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .case-details-page-container {
    width: 100%;
    min-width: 1240px;
    position: relative;

    .case-details-container {
      margin-top: 74px;

      .title {
        margin: 120px 0 80px 0;

        .main-title {
          position: relative;
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #000000;
          text-align: center;

          &::after {
            position: absolute;
            bottom: -20px;
            right: 50%;
            transform: translateX(50%);
            display: block;
            content: "";
            width: 120px;
            height: 2px;
            background: #000000;
          }
        }

        .sub-title {
          margin-top: 42px;
          font-family: PingFangSC-Regular;
          font-size: 18px;
          color: #000000;
          text-align: center;
        }
      }

      .case-img-container {
        display: flex;
        justify-content: center;
        margin: 0 auto;
        margin-bottom: 80px;
        //width: 60vw;
        width: 1200px;

        img {
          // width: 1200px;
          // height: 6356px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/case/caseDetailsPage.vue